import React, { useState } from "react";
import MarketingBanner2 from "../marketing/MarketingBanner2";
import {
  boardTypes,
  dateAddMinute,
  getTexts,
  propertyFromArray,
  roomTypes,
  roomViews,
  views,
} from "../utils";

import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";

import { MdAirplanemodeActive, MdOutlineLocalOffer } from "react-icons/md";
import { useSelector, useDispatch } from "react-redux";
import { selectSearch } from "amadeusredux/lib/searchSlice";

import { selectSystem, setView } from "amadeusredux/lib/systemSlice";
import {
  checkOfferAction,
  clearMarketingActions,
  searchAlternativeTransports,
  //searchAlternativeFlights,
  searchBetterOffers,
  setMarked,
  setOfferFlexbooked,
} from "amadeusredux/lib/hotelSlice";
import {
  availabilityAndPriceCheck,
  getLink2Share,
  setOfferMemo,
} from "amadeusredux/lib/api";

import {
  availableOfferData,
  getPassinfo,
  getTermsAndConditions,
  setInboundView,
  setTheOffer,
} from "amadeusredux/lib/bookingSlice";

import { MdContentCopy } from "react-icons/md";
import { BsWhatsapp } from "react-icons/bs";
import { AiOutlineMail } from "react-icons/ai";
import { FaShareAlt, FaHeart } from "react-icons/fa";
import FlightLocations from "./FlightLocations";
import OfferFlight from "./OfferFlight";
import AvailabilityButton from "../AvailabilityButton";
import HotelOfferVoucher from "../components/HotelOfferVoucher";
import { currencySymbol } from "../utils.js";
import { unwrapResult } from "@reduxjs/toolkit";
import Select from "react-select";
import { getalternativeTransports } from "../offerutils";

const nf = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 2,
  maxiimumFractionDigits: 2,
});

const checkBetter = (offer, suboffer) => {
  let betterOffer = 0;
  let betterOption = { better: false, options: [] };
  if (
    !(
      offer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
        .DepartureTime ===
        suboffer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
          .DepartureTime &&
      offer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
        .DepartureTime ===
        suboffer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
          .DepartureTime
    )
  )
    return betterOption;

  /*if (offer.PriceInfo.Price.value > suboffer.PriceInfo.Price.value)
    return betterOption;*/

  if (
    offer.TourOperator.TourOperatorName !==
    suboffer.TourOperator.TourOperatorName
  )
    return betterOption;

  if (offer.OfferID === suboffer.OfferID) return betterOption;

  return { better: true, options: [] };

  /*let roomTypeOfferOrder = roomTypes.find(
    (e) => e.value === offer.OfferServices.Package.Accommodation.Room.RoomType
  ).order;
  let roomTypeSubOfferOrder = roomTypes.find(
    (e) =>
      e.value === suboffer.OfferServices.Package.Accommodation.Room.RoomType
  ).order;

  betterOffer = betterOffer + (roomTypeSubOfferOrder - roomTypeOfferOrder);
  if (roomTypeSubOfferOrder - roomTypeOfferOrder < 0) {
    return betterOption;
  }

  if (roomTypeSubOfferOrder - roomTypeOfferOrder > 0) {
    betterOption.options.push("roomType");
  }

  if (
    offer.OfferServices.Package.Accommodation.Room.RoomName !==
    suboffer.OfferServices.Package.Accommodation.Room.RoomName
  ) {
    betterOffer = betterOffer + 1;
    betterOption.options.push("roomName");
  }

  let boardTypeOfferOrder = boardTypes.find(
    (e) => e.value === offer.OfferServices.Package.Accommodation.BoardType
  ).order;
  let boardTypeSubOfferOrder = boardTypes.find(
    (e) => e.value === suboffer.OfferServices.Package.Accommodation.BoardType
  ).order;

  betterOffer = betterOffer + (boardTypeSubOfferOrder - boardTypeOfferOrder);

  if (boardTypeSubOfferOrder - boardTypeOfferOrder < 0) {
    return betterOption;
  }

  if (boardTypeSubOfferOrder - boardTypeOfferOrder > 0) {
    betterOption.options.push("boardType");
  }

  let roomViewOfferOrder = roomViews.find(
    (e) => e.value === offer.OfferServices.Package.Accommodation.Room.RoomView
  ).order;
  let roomViewSubOfferOrder = roomViews.find(
    (e) =>
      e.value === suboffer.OfferServices.Package.Accommodation.Room.RoomView
  ).order;

  betterOffer = betterOffer + (roomViewSubOfferOrder - roomViewOfferOrder);

  if (roomViewSubOfferOrder - roomViewOfferOrder < 0) {
    return betterOption;
  }

  if (roomViewSubOfferOrder - roomViewOfferOrder > 0) {
    betterOption.options.push("roomView");
  }

  let transferinclOffer = 0;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclOffer = 1;
    }
  }

  let transferinclSubOffer = 0;
  if (suboffer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(suboffer.OfferProperties.TransferInfos) &&
      suboffer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclSubOffer = 1;
    }
  }

  betterOffer = betterOffer + (transferinclSubOffer - transferinclOffer);

  if (transferinclSubOffer - transferinclOffer < 0) {
    return betterOption;
  }

  if (transferinclSubOffer - transferinclOffer > 0) {
    betterOption.options.push("transfer");
  }

  let railandflyOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflyOffer = 1;
    }
  }

  let railandflySubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflySubOffer = 1;
    }
  }
  betterOffer = betterOffer + (railandflySubOffer - railandflyOffer);

  if (railandflySubOffer - railandflyOffer < 0) {
    return betterOption;
  }

  if (railandflySubOffer - railandflyOffer > 0) {
    betterOption.options.push("railandfly");
  }

  let cancellationOffer = 0;
  if (offer.OfferProperties.CancellationOption === "Free")
    cancellationOffer = 3;
  if (offer.OfferProperties.CancellationOption === "Addable")
    cancellationOffer = 2;
  if (offer.OfferProperties.CancellationOption === "Paid")
    cancellationOffer = 1;

  let cancellationSubOffer = 0;
  if (suboffer.OfferProperties.CancellationOption === "Free")
    cancellationSubOffer = 3;
  if (suboffer.OfferProperties.CancellationOption === "Addable")
    cancellationSubOffer = 2;
  if (suboffer.OfferProperties.CancellationOption === "Paid")
    cancellationSubOffer = 1;

  betterOffer = betterOffer + (cancellationSubOffer - cancellationOffer);

  if (cancellationSubOffer - cancellationOffer < 0) {
    return betterOption;
  }

  if (cancellationSubOffer - cancellationOffer > 0) {
    betterOption.options.push("cancellation");
  }

  if (betterOffer > 0) betterOption.better = true;

  return betterOption;*/
};

const checkDifference = (offer, suboffer) => {
  let betterOffer = 0;
  let betterOption = { better: false, options: [] };
  if (
    !(
      offer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
        .DepartureTime ===
        suboffer?.OfferServices?.Package?.Flight?.OutboundFlight.FlightDeparture
          .DepartureTime &&
      offer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
        .DepartureTime ===
        suboffer?.OfferServices?.Package?.Flight?.InboundFlight.FlightDeparture
          .DepartureTime
    )
  )
    return betterOption;

  /*if (offer.PriceInfo.Price.value > suboffer.PriceInfo.Price.value)
    return betterOption;*/

  if (
    offer.TourOperator.TourOperatorName !==
    suboffer.TourOperator.TourOperatorName
  )
    return betterOption;

  if (offer.OfferID === suboffer.OfferID) return betterOption;

  betterOption.better = true;

  if (
    offer.OfferServices.Package.Accommodation.Room.RoomName !==
    suboffer.OfferServices.Package.Accommodation.Room.RoomName
  ) {
    betterOption.options.push("roomName");
  }

  if (
    offer.OfferServices.Package.Accommodation.Room.RoomView !==
    suboffer.OfferServices.Package.Accommodation.Room.RoomView
  ) {
    betterOption.options.push("roomView");
  }

  if (
    offer.OfferServices.Package.Accommodation.BoardType !==
    suboffer.OfferServices.Package.Accommodation.BoardType
  ) {
    betterOption.options.push("boardType");
  }

  let transferinclOffer = 0;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclOffer = 1;
    }
  }

  let transferinclSubOffer = 0;
  if (suboffer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(suboffer.OfferProperties.TransferInfos) &&
      suboffer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferinclSubOffer = 1;
    }
  }

  if (transferinclSubOffer - transferinclOffer < 0) {
    betterOption.options.push("transferNotIncluded");
  }

  if (transferinclSubOffer - transferinclOffer > 0) {
    betterOption.options.push("transferIncluded");
  }

  let railandflyOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflyOffer = 1;
    }
  }

  let railandflySubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandflySubOffer = 1;
    }
  }

  if (railandflySubOffer - railandflyOffer < 0) {
    betterOption.options.push("railandflyNotIncluded");
  }

  if (railandflySubOffer - railandflyOffer > 0) {
    betterOption.options.push("railandflyIncluded");
  }

  let rentalcarOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RentalCar")
    ) {
      rentalcarOffer = 1;
    }
  }

  let rentalcarSubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("RentalCar")
    ) {
      rentalcarSubOffer = 1;
    }
  }

  if (rentalcarSubOffer - rentalcarOffer < 0) {
    betterOption.options.push("rentalcarNotIncluded");
  }

  if (rentalcarSubOffer - rentalcarOffer > 0) {
    betterOption.options.push("rentalcarIncluded");
  }

  let freerebookOffer = 0;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("FreeRebooking")
    ) {
      freerebookOffer = 1;
    }
  }

  let freerebookSubOffer = 0;
  if (suboffer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
      suboffer.OfferProperties.OfferIncludes.includes("FreeRebooking")
    ) {
      freerebookSubOffer = 1;
    }
  }

  if (freerebookSubOffer - freerebookOffer < 0) {
    betterOption.options.push("freerebookNotIncluded");
  }

  if (freerebookSubOffer - freerebookOffer > 0) {
    betterOption.options.push("freerebookIncluded");
  }

  let cancellationOffer = 0;
  if (offer?.OfferProperties?.CancellationOption === "Free")
    cancellationOffer = 3;
  if (offer?.OfferProperties?.CancellationOption === "Addable")
    cancellationOffer = 2;
  if (offer?.OfferProperties?.CancellationOption === "Paid")
    cancellationOffer = 1;

  let cancellationSubOffer = 0;
  if (suboffer?.OfferProperties?.CancellationOption === "Free")
    cancellationSubOffer = 3;
  if (suboffer?.OfferProperties?.CancellationOption === "Addable")
    cancellationSubOffer = 2;
  if (suboffer?.OfferProperties?.CancellationOption === "Paid")
    cancellationSubOffer = 1;

  if (cancellationSubOffer - cancellationOffer < 0) {
    betterOption.options.push("cancellationDowngrade");
  }

  if (cancellationSubOffer - cancellationOffer > 0) {
    betterOption.options.push("cancellationUpgrade");
  }

  return betterOption;
};

export default function HotelClassicViewOffer(props) {
  const {
    offer,
    hotels,
    geodata,
    stations,
    offCount,
    parentOffer,
    betterOption,
    alternatives,
  } = props;
  const intl = useIntl();
  const nf = new Intl.NumberFormat(intl.locale, { minimumFractionDigits: 2 });

  const df = new Intl.DateTimeFormat(intl.locale, {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const df2 = new Intl.DateTimeFormat(intl.locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  const tf = new Intl.DateTimeFormat(intl.locale, {
    hour: "2-digit",
    minute: "2-digit",
  });
  const [alternativeFlightPage, setAlternativeFlightPage] = React.useState(1);
  const voucherRef = React.useRef();
  let offsetTop = 0;

  if (voucherRef?.current?.offsetTop) offsetTop = voucherRef.current.offsetTop;
  const dispatch = useDispatch();
  const sessionId = useSelector((state) => state.system.sessionId);
  const [checkBetterId, setCheckBetterId] = React.useState("");
  const [flexSelected, setFlexSelected] = React.useState(false);
  const airports = stations?.Station;
  const hotel = hotels.Hotel.find(
    (e) =>
      e.HotelID === offer.OfferServices.Package.Accommodation.HotelRef.HotelID
  );
  const { loading } = useSelector(selectSystem);

  const checkids = useSelector((state) => state.hotel.checkids);
  const subload = useSelector((state) => state.hotel.subload);
  const otherids = useSelector((state) => state.hotel.otherids);
  const alternativeids = useSelector((state) => state.hotel.alternativeids);

  const holidayType = useSelector((state) => state.search.holidayType);
  const alternativeTransports = useSelector((state) =>
    state.hotel.alternativeTransports[offer.OfferID]
      ? state.hotel.alternativeTransports[offer.OfferID]
      : {}
  );

  const outboundFlight = offer?.OfferServices?.Package?.Flight?.OutboundFlight;
  const inboundFlight = offer?.OfferServices?.Package?.Flight?.InboundFlight;
  const searchOptions = useSelector(selectSearch);

  //console.log(alternativeFlightsBeforeCheck);
  //console.log(offer.TourOperator.TourOperatorCode);

  const [selectedOutboundAirport, setSelectedOutboundAirport] = React.useState({
    value: "",
    label: "Bitte Flughafen auswählen",
  });
  const [selectedDeparture, setSelectedDeparture] = React.useState({
    value: "",
    label: "Bitte Abflugzeit auswählen",
  });

  const [selectedArrival, setSelectedArrival] = React.useState({
    value: "",
    label: "Bitte Rückflugzeit auswählen",
  });

  React.useEffect(() => {
    /*if (selectedArrival.value != "")
      setSelectedDeparture({ value: "", label: "Bitte Abflugzeit auswählen" });*/
    setAlternativeFlightPage(1);
  }, [selectedArrival]);

  React.useEffect(() => {
    /*if (selectedDeparture.value != "")
      setSelectedArrival({ value: "", label: "Bitte Rückflugzeit auswählen" });*/
    setAlternativeFlightPage(1);
  }, [selectedDeparture]);

  React.useEffect(() => {
    setSelectedDeparture({ value: "", label: "Bitte Abflugzeit auswählen" });
    setSelectedArrival({ value: "", label: "Bitte Rückflugzeit auswählen" });
    setAlternativeFlightPage(1);
  }, [selectedOutboundAirport]);

  let outboundStations = [];
  let inboundStations = [];
  let ats = getalternativeTransports(alternativeTransports, airports, df2);

  outboundStations = ats.outboundStations;
  inboundStations = ats.inboundStations;

  for (let i = 0; i < outboundStations.length; i++) {
    outboundStations[i].times = outboundStations[i].times
      .sort((a, b) => a.date.localeCompare(b.date))
      .sort((a, b) => a.time.localeCompare(b.time));
  }

  for (let i = 0; i < inboundStations.length; i++) {
    inboundStations[i].times = inboundStations[i].times
      .sort((a, b) => a.date.localeCompare(b.date))
      .sort((a, b) => a.time.localeCompare(b.time));
  }

  let offerrealprice = 0;
  let offerbetterprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    offerrealprice =
      offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
      offerbetterprice =
      offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    offerrealprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
      offerbetterprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  if (
    Array.isArray(offer?.MarketingActions) &&
    offer?.MarketingActions.length > 0 &&
    offer?.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice &&
    flexSelected
  ) {
    offerbetterprice +=
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice *
      1;
  }

  const betterOffers = useSelector(
    (state) => state.hotel.betterOffers[offer.OfferID]
  );

  const getBetterOffers = (
    withActions,
    forceClear,
    theoffer,
    cross,
    subload
  ) => {
    if (!theoffer?.OfferID) {
      theoffer = {};
    }
    if (
      Array.isArray(betterOffers) &&
      betterOffers.length > 0 &&
      forceClear !== true
    )
      return;

    if (
      Array.isArray(otherids) &&
      otherids.includes(offer.OfferID) &&
      forceClear !== true
    )
      return;

    if (checkBetterId !== theoffer.OfferID ? theoffer.OfferID : offer.OfferID) {
      let obf = offer?.OfferServices?.Package?.Flight?.OutboundFlight;
      let ibf = offer?.OfferServices?.Package?.Flight?.InboundFlight;

      if (theoffer.OfferID) {
        obf = theoffer?.OfferServices?.Package?.Flight?.OutboundFlight;
        ibf = theoffer?.OfferServices?.Package?.Flight?.InboundFlight;
      }

      dispatch(
        searchBetterOffers({
          fromDate: holidayType.flight
            ? obf.FlightDeparture.DepartureDate
            : offer.TravelDateInfo.CheckInDate,
          //outboundtime: "00:00-23:59",
          outboundtime: holidayType.flight
            ? obf.FlightDeparture.DepartureTime +
              "-" +
              dateAddMinute(obf.FlightDeparture.DepartureTime)
            : "",
          untilDate: holidayType.flight
            ? ibf.FlightDeparture.DepartureDate
            : offer.TravelDateInfo.CheckOutDate,
          inboundtime: holidayType.flight
            ? ibf.FlightDeparture.DepartureTime +
              "-" +
              dateAddMinute(ibf.FlightDeparture.DepartureTime)
            : "",
          //inboundtime: "00:00-23:59",
          station: holidayType.flight
            ? obf.FlightDeparture.DepartureAirportRef.AirportCode
            : "",

          touroperator: theoffer.OfferID
            ? theoffer.TourOperator.TourOperatorCode
            : offer.TourOperator.TourOperatorCode,
          searchOptions: searchOptions,
          selectedDestination: [hotel],
          parentid: theoffer.OfferID ? theoffer.OfferID : offer.OfferID,
          withActions: withActions,
          forceClear: forceClear,
          cross: cross,
          subload: subload,
        })
      )
        .then(unwrapResult)
        .then((originalPromiseResult) => {
          //console.log(originalPromiseResult);
          setCheckBetterId("");
        });
      setCheckBetterId(theoffer.OfferID ? theoffer.OfferID : offer.OfferID);
    }
  };

  const getAlternativeTransports = (offset, withActions, theoffer, cross) => {
    if (!theoffer?.OfferID) {
      theoffer = {};
    }
    if (Array.isArray(alternativeids) && alternativeids.includes(offer.OfferID))
      return;
    if (
      Array.isArray(alternativeTransports) &&
      alternativeTransports.length > 0
    )
      return;

    if (offer?.OfferServices?.Package?.Flight)
      dispatch(
        searchAlternativeTransports({
          withActions: withActions,
          offer: theoffer ? theoffer : offer,
          offset: offset,
          cross: cross,
        })
      )
        .then(unwrapResult)
        .then((originalPromiseResult) => {
          //console.log(originalPromiseResult);
          if (
            originalPromiseResult.Offers.MoreOffersAvailable &&
            withActions !== false
          ) {
            getAlternativeTransports(
              offset + originalPromiseResult.Offers.OfferCount,
              withActions,
              theoffer.OfferID ? theoffer : undefined,
              cross
            );
          }
        });
  };

  React.useEffect(() => {
    if (!offer) return;

    if (
      offCount <= 10 &&
      !offer.bookinginfo &&
      Array.isArray(checkids) &&
      !checkids.includes(offer.OfferID)
    ) {
      availabilityAndPriceCheck(
        dispatch,
        sessionId,
        offer.OfferID,
        offer.adults,
        offer.children,
        undefined
      );
      //getAlternativeTransports();
      //getBetterOffers();
    }
  }, [checkids, offer]);

  React.useEffect(() => {
    if (holidayType.flight) {
      //getAlternativeTransports(0, false);
    }
    //getBetterOffers(false);
    setAlternativeFlightPage(1);
  }, [offer]);

  React.useEffect(() => {
    if (subload) {
      if (holidayType.flight) {
        getAlternativeTransports(0, false, offer, false);
      }
      getBetterOffers(false, false, offer, false, false);
    }
  }, [subload]);

  React.useEffect(() => {
    if (offer?.bookinginfo?.Status?.Status === "Available") {
      if (
        !(
          Array.isArray(offer?.MarketingActions) &&
          offer.MarketingActions.length > 0 &&
          offer.MarketingActions[0].MarketingProperties.offeraction === true
        )
      )
        dispatch(checkOfferAction({ offerId: offer.OfferID, offer: offer }));
    }
  }, [offer, offer?.bookinginfo]);

  const [showAlternatives, setShowAlternatives] = useState(false);

  const [showAlternativeTransports, setShowAlternativeTransports] =
    useState(false);
  const [shareOptionsHidden, setShareOptionsHidden] = React.useState(true);
 
  let checked = false;
  if (offer?.bookinginfo) checked = true;

  let transferincl = false;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferincl = true;
    }
  }
  let railandfly = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandfly = true;
    }
  }
  let txts = getTexts(offer.OfferProperties?.OfferFeatures, [
    "Storno:",
    "Storno mit Gebühr:",
    "Umb:",
    "Opt Flex:",
    "Sonst:",
  ]);
  //console.log(txts);
  /*let cancellationText = "";
  let rebookingText = "";
  let addableText = "";
  if (offer.OfferProperties?.OfferFeatures) {
    cancellationText = offer.OfferProperties.OfferFeatures.split("Storno:")[1];
    if (cancellationText) {
      if (cancellationText.indexOf("Umb:") > -1) {
        cancellationText = cancellationText.split("Umb:")[0];
      }
      if (cancellationText.indexOf("Opt Flex:") > -1) {
        cancellationText = cancellationText.split("Opt ")[0];
      }
      cancellationText = cancellationText.trim();
      if (cancellationText.endsWith(",")) {
        cancellationText = cancellationText.split(",")[0];
      }
    }

    rebookingText = offer.OfferProperties.OfferFeatures.split("Umb:")[1];
    if (rebookingText) {
      if (rebookingText.indexOf("Opt Flex:") > -1) {
        rebookingText = rebookingText.split("Opt ")[0];
      }
      rebookingText = rebookingText.trim();
      if (rebookingText.endsWith(",")) {
        rebookingText = rebookingText.split(",")[0];
      }
    }
    addableText = offer.OfferProperties.OfferFeatures.split("Opt Flex:")[1];
    if (addableText) {
      addableText = addableText.trim();
      if (addableText.endsWith(",")) {
        addableText = addableText.split(",")[0];
      }
    }
  }*/

  let betteroffers = false;
  if (Array.isArray(betterOffers?.Offers?.Offer)) {
    if (betterOffers?.Offers?.Offer.length > 1) {
      betteroffers = true;
    }
  }

  let cancellationoption = "";
  if (offer?.OfferProperties?.CancellationOption) {
    cancellationoption = offer?.OfferProperties?.CancellationOption;
  }

  let outboundWeight = 0;
  if (
    Array.isArray(
      offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
        ?.FlightSegment
    ) &&
    offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
      ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight
  ) {
    outboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
        ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight * 1;
  } else if (
    offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
      ?.FlightSegment?.BaggageAllowance?.MaxWeight
  ) {
    outboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.OutboundFlightSegments
        ?.FlightSegment?.BaggageAllowance?.MaxWeight * 1;
  }
  let inboundWeight = 0;

  if (
    Array.isArray(
      offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
        ?.FlightSegment
    ) &&
    offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
      ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight
  ) {
    inboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
        ?.FlightSegment[0]?.BaggageAllowance?.MaxWeight * 1;
  } else if (
    offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
      ?.FlightSegment?.BaggageAllowance?.MaxWeight
  ) {
    inboundWeight =
      offer?.bookinginfo?.Offer?.Package?.Flight?.InboundFlightSegments
        ?.FlightSegment?.BaggageAllowance?.MaxWeight * 1;
  }
  let realprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    realprice = offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  }

  let status = 0;

  if (offer?.bookinginfo) {
    if (
      offer?.bookinginfo?.Status?.Status === "Available" ||
      offer?.bookinginfo?.Status?.Status === "ToConfirm" ||
      offer?.bookinginfo?.Status?.Status === "OnRequest"
    ) {
      status = 1;
    } else {
      status = -1;
    }
  }
  let outboundAirport = {};
  if (outboundFlight?.FlightDeparture) {
    outboundAirport = airports.find(
      (e) =>
        e.StationCode ===
        outboundFlight.FlightDeparture.DepartureAirportRef.AirportCode
    );
  }

  let inboundAirport = {};
  if (inboundFlight?.FlightDeparture) {
    inboundAirport = airports.find(
      (e) =>
        e.StationCode ===
        inboundFlight.FlightDeparture.DepartureAirportRef.AirportCode
    );
  }

  let betterButton = false;
  /*if (checkBetterId === offer.OfferID && Array.isArray(betterOffers?.Offers?.Offer) && betterOffers.Offers.Offer.filter((e) => !checkDifference(offer, e).better).length === 0) {
    betterButton = false;
  }

  if (checkBetterId === offer.OfferID && !Array.isArray(betterOffers?.Offers?.Offer)) {
    betterButton = false;
  }*/

  if (Array.isArray(betterOffers?.Offers?.Offer)) {
    let offs = betterOffers.Offers.Offer.filter((suboffer) => {
      //let betterOption = checkBetter(offer, suboffer);
      let betterOption = checkDifference(offer, suboffer);
      return betterOption.better;
    });
    if (offs.length > 0) betterButton = true;
  }

  if (
    Array.isArray(offer.MarketingActions) &&
    offer.MarketingActions.length > 0 &&
    !isNaN(
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice
    ) &&
    offer.MarketingActions[0].flexconditions?.flexoptions?.flexoption
  ) {
    betterButton = true;
  }

  let alternativeTransportsButton = false;

  if (Array.isArray(alternativeTransports?.Offers?.Offer)) {
    let offs = alternativeTransports.Offers.Offer.filter((suboffer) => {
      return offer.OfferID !== suboffer.OfferID;
    });
    if (offs.length > 1) alternativeTransportsButton = true;
  }

  let oddalternativeTransports = false;
  let ct = 0;
  let even = false;
  let evenflight = false;
  let afct = 0;
  /* console.log(
    offer?.TourOperator?.TourOperatorName,
    betterOffers?.Offers?.Offer
  );*/
  return (
    <>
      <span ref={voucherRef}></span>
      <HotelOfferVoucher
        offer={offer}
        extended={showAlternatives || showAlternativeTransports}
        alternativeTransportsButton={
          <>
            {alternativeTransportsButton && (
              <span
                className="hotelofferframe3"
                onClick={() => {
                  if (!showAlternativeTransports) {
                    getAlternativeTransports(0, true, offer, true);
                    setShowAlternativeTransports(true);
                    setShowAlternatives(false);
                  } else {
                    setShowAlternativeTransports(false);
                  }
                }}
              >
                {!showAlternativeTransports ? (
                  <span className="hotelofferframe4">
                    Alternative Flüge &#x25B4;
                  </span>
                ) : (
                  <span className="hotelofferframe5">
                    Alternative Flüge &#x25BE;
                  </span>
                )}
              </span>
            )}
          </>
        }
        betterOffersButton={
          <>
            {betterButton && (
              <span
                className="hotelofferframe3"
                onClick={() => {
                  if (!showAlternatives) {
                    getBetterOffers(true, true, offer, true, true);

                    setShowAlternativeTransports(false);
                    setShowAlternatives(true);
                  } else {
                    setShowAlternatives(false);
                  }
                }}
              >
                {!showAlternatives ? (
                  <span className="hotelofferframe4">
                    Bessere Leistungen &#x25B4; 
                  </span>
                ) : (
                  <span className="hotelofferframe5">
                    Bessere Leistungen &#x25BE;
                  </span>
                )}
              </span>
            )}
          </>
        }
        availabilityButton={
          <AvailabilityButton
            offer={offer}
            hotel={hotel}
            isVoucher={true}
            inboundView={views.hotelclassicview}
          />
        }
      />
      <div className={loading > 0 ? "load" : null} style={{ display: "flex" }}>
        <div style={{ flexGrow: 1 }}>{alternatives && <></>}</div>
        
      </div>
      {betteroffers && showAlternatives && (
        <>
          <div
            className={
              "classicoptions " +
              (status === -1 ? "voucherno" : status === 1 ? "voucheryes" : "")
            }
          >
            <div className="hotelofferframe14">
              {Array.isArray(offer.MarketingActions) &&
                offer.MarketingActions.length > 0 &&
                !isNaN(
                  offer.MarketingActions[0].flexconditions?.flexoptions
                    ?.flexoptionprice
                ) &&
                offer.MarketingActions[0].flexconditions?.flexoptions
                  ?.flexoption && (
                  <div className="offerupgrade">
                    <div className="offerupgradeitem">
                      <div
                        className="offerupgradeitemlabelflex"
                        style={{ fontSize: "12pt" }}
                      >
                        {!offer.flexbooked ? <>+&nbsp;</> : <>-&nbsp;</>}
                        {
                          offer.MarketingActions[0].flexconditions?.flexoptions
                            ?.flexoptiontext
                        }
                      </div>
                      <div
                        className="offerupgradeitemprice"
                        onClick={() => {
                          //window.scrollTo(0, offsetTop);
                          //dispatch(setOfferId(otherRailOffer.OfferID));
                        }}
                      >
                        {!offer.flexbooked ? <>+&nbsp;</> : <>-&nbsp;</>}
                        {
                          offer.MarketingActions[0].flexconditions?.flexoptions
                            ?.flexoptionprice
                        }{" "}
                        {offer.PriceInfo.Price.CurrencyCode}
                        &nbsp;&nbsp;(
                        {offerrealprice +
                          offer.MarketingActions[0].flexconditions?.flexoptions
                            ?.flexoptionprice *
                            1}{" "}
                        {offer.PriceInfo.Price.CurrencyCode})
                      </div>
                      <div
                        style={{
                          paddingLeft: 8,
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <AvailabilityButton
                          offer={offer}
                          hotel={hotel}
                          inboundView={views.hotelcrossview}
                          availableAction={(off) => {
                            let fb = !offer.flexbooked;
                            setFlexSelected(fb);

                            dispatch(clearMarketingActions(offer.OfferID));
                            dispatch(
                              checkOfferAction({
                                offerId: offer.OfferID,
                                offer: {
                                  ...offer,
                                  flexbooked: fb,
                                },
                              })
                            );

                            dispatch(
                              setOfferFlexbooked({
                                offerId: offer.OfferID,
                                flexbooked: fb,
                              })
                            );
                          }}
                          availableText={"übernehmen"}
                        />
                        <div className="growbox" />
                      </div>
                    </div>
                  </div>
                )}
              {betterOffers.Offers.Offer.map((suboffer, i) => {
                //let betterOption = checkBetter(offer, suboffer);
                let betterOption = checkDifference(offer, suboffer);
                if (betterOption.better) {
                  even = !even;
                  ct = ct + 1;
                }
                if (
                  ct <= 10 &&
                  betterOption.better &&
                  !suboffer?.bookinginfo &&
                  Array.isArray(checkids) &&
                  !checkids.includes(suboffer.OfferID)
                ) {
                  availabilityAndPriceCheck(
                    dispatch,
                    sessionId,
                    suboffer.OfferID,
                    suboffer.adults,
                    suboffer.children,
                    offer.OfferID
                  );
                }
                //outboundFlight.FlightDeparture.DepartureTime
                return betterOption.better ? (
                  //return true ? (
                  <div
                    className={even ? "offerupgradeitem1" : "offerupgradeitem2"}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: 8,
                    }}
                  >
                    {/*JSON.stringify(betterOption)*/}
                    <br />

                    <div
                      className="offerupgradeitemlabel"
                      style={{ fontSize: "12pt" }}
                    >
                      {Array.isArray(betterOption?.options) &&
                        betterOption.options.map((option) => {
                          let optionsign = "+";
                          let optionvalue = "";
                          if (option === "roomName")
                            optionvalue =
                              suboffer.OfferServices.Package.Accommodation.Room
                                .RoomName;
                          if (
                            option === "roomView" &&
                            suboffer.OfferServices.Package.Accommodation.Room
                              .RoomView !== "NothingSpecial"
                          )
                            optionvalue = propertyFromArray(
                              roomViews,
                              suboffer.OfferServices.Package.Accommodation.Room
                                .RoomView,
                              "value",
                              "label"
                            );
                          if (
                            option === "roomView" &&
                            suboffer.OfferServices.Package.Accommodation.Room
                              .RoomView === "NothingSpecial"
                          ) {
                            optionsign = "-";
                            optionvalue = "keine definierte Aussicht";
                          }
                          if (option === "boardType")
                            optionvalue = propertyFromArray(
                              boardTypes,
                              suboffer.OfferServices.Package.Accommodation
                                .BoardType,
                              "value",
                              "label"
                            );

                          if (option === "transferNotIncluded") {
                            optionsign = "-";
                            optionvalue = "Hoteltransfer im Zielgebiet";
                          }
                          if (option === "transferIncluded")
                            optionvalue = "Hoteltransfer im Zielgebiet";
                          if (option === "railandflyNotIncluded") {
                            optionsign = "-";
                            optionvalue = "Rail&Fly";
                          }
                          if (option === "railandflyIncluded")
                            optionvalue = "Rail&Fly";
                          if (option === "rentalcarNotIncluded") {
                            optionsign = "-";
                            optionvalue = "Mietwagen";
                          }
                          if (option === "rentalcarIncluded")
                            optionvalue = "Mietwagen";
                          if (option === "freerebookNotIncluded") {
                            optionsign = "-";
                            optionvalue = "kostenlose Umbuchung";
                          }
                          if (option === "freerebookIncluded")
                            optionvalue = "kostenlose Umbuchung";

                          let cancellationoption = "";
                          if (suboffer?.OfferProperties?.CancellationOption) {
                            cancellationoption =
                              suboffer?.OfferProperties?.CancellationOption;
                          }

                          if (option === "cancellationDowngrade") {
                            optionsign = "-";
                            optionvalue = "Cancellation" + cancellationoption;
                          }
                          if (option === "cancellationUpgrade")
                            optionvalue = "Cancellation" + cancellationoption;

                          return (
                            <div style={{ display: "flex" }}>
                              <div style={{ minWidth: 15 }}>{optionsign}</div>{" "}
                              <div>{optionvalue} </div>
                            </div>
                          );
                        })}
                    </div>
                    {/*<div style={{ flex: "10%" }}>
                    {JSON.stringify(betterOption)}
                    {propertyFromArray(
                      boardTypes,
                      suboffer.OfferServices.Package.Accommodation.BoardType,
                      "value",
                      "label"
                    )}
                  </div>
                  <div style={{ flex: "10%" }}>
                    {suboffer.OfferServices.Package.Accommodation.Room.RoomName}
                  </div>

                  {suboffer.OfferServices.Package.Accommodation.Room.RoomView !==
                    "NothingSpecial" ? (
                    <div style={{ flex: "10%" }}>
                      {propertyFromArray(
                        roomViews,
                        suboffer.OfferServices.Package.Accommodation.Room.RoomView,
                        "value",
                        "label"
                      )}
                    </div>
                  ) : null}

                  <div style={{ flex: "10%" }}>
                    {Array.isArray(suboffer.OfferProperties.TransferInfos) &&
                      suboffer.OfferProperties.TransferInfos.includes(
                        "TransferIncluded"
                      ) ? (
                      <>
                        <FormattedMessage id="transferincluded" />
                        <br />
                      </>
                    ) : (
                      <>
                        <FormattedMessage id="transfernotincluded" />
                        <br />
                      </>
                    )}
                  </div>
                  <div style={{ flex: "10%" }}>
                    {Array.isArray(suboffer.OfferProperties.OfferIncludes) &&
                      suboffer.OfferProperties.OfferIncludes.includes(
                        "RailAndFly"
                      ) ? (
                      <>
                        Zug zum Flug
                        <br />
                      </>
                    ) : null}
                  </div>
                  <div style={{ flex: "10%" }}>
                    <FormattedNumber
                      value={
                        suboffer.PriceInfo.Price.value *
                        (offer.adults * 1 + offer.children * 1)
                      }
                      minimumFractionDigits={2}
                      maximumFractionDigits={2}
                    />
                    &nbsp;{suboffer.PriceInfo.Price.CurrencyCode}
                    </div>


                  <div
                    style={{ flex: "0 0 3%", cursor: "pointer" }}
                    onClick={() => props.changeChoosenOffers(suboffer)}
                  >
                    auswählen
                    </div>*/}
                    <Offerprice
                      dispatch={dispatch}
                      clickAction={(off) => {
                        let theoff = { ...off };
                        theoff.flexbooked = flexSelected;
                        props.changeChoosenOffers(off);
                        setShowAlternatives(false);
                      }}
                      flexSelected={flexSelected}
                      offer={offer}
                      co={suboffer}
                    />
                    <div
                      style={{
                        paddingLeft: 8,
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <AvailabilityButton
                        offer={suboffer}
                        hotel={hotel}
                        inboundView={views.hotelclassicview}
                        parentid={offer.OfferID}
                        availableAction={(off) => {
                          let theoff = { ...off };
                          theoff.flexbooked = flexSelected;
                          getAlternativeTransports(0, true, suboffer, true);
                          getBetterOffers(true, false, suboffer, true, true);
                          props.changeChoosenOffers(theoff);
                          setShowAlternatives(false);
                          window.scrollTo(0, offsetTop);
                        }}
                        availableText={"übernehmen"}
                      />
                    </div>
                    {/*<HotelOfferFrame
                  alternatives={false}
                  offer={suboffer}
                  hotels={hotels}
                  geodata={geodata}
                  stations={betterOffers.StationDictionary}
                  searchOptions={searchOptions}
                  parentOffer={offer}
                  betterOption={betterOption}
              />*/}
                  </div>
                ) : null;
              })}
            </div>
          </div>
        </>
      )}

      {alternativeTransports && showAlternativeTransports && (
        <>
          {Array.isArray(alternativeTransports?.Offers?.Offer) &&
            alternativeTransports?.Offers?.Offer.length > 1 && (
              <>
                <div
                  style={{
                    display: "flex",
                    borderBottomWidth: 0,
                    paddingTop: 8,
                  }}
                  className={
                    "classicoptions " +
                    (status === -1
                      ? "voucherno"
                      : status === 1
                      ? "voucheryes"
                      : "")
                  }
                >
                  <div style={{ flexGrow: 1 }}>
                    <Select
                      options={[
                        {
                          value: "",
                          label: "Bitte Flughafen auswählen",
                        },
                        ...outboundStations,
                      ]}
                      value={selectedOutboundAirport}
                      onChange={(val) => {
                        setSelectedOutboundAirport(val);
                      }}
                    />
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <Select
                      options={
                        Array.isArray(outboundStations) &&
                        selectedOutboundAirport.value
                          ? [
                              {
                                value: "",
                                label: "Bitte Abflugzeit auswählen",
                              },
                              ...outboundStations.find(
                                (e) => e.value === selectedOutboundAirport.value
                              ).times,
                            ]
                          : []
                      }
                      value={selectedDeparture}
                      isDisabled={!selectedOutboundAirport?.value}
                      onChange={(val) => {
                        setSelectedDeparture(val);
                      }}
                    />
                  </div>

                  <div style={{ flexGrow: 1 }}>
                    <Select
                      options={
                        Array.isArray(inboundStations) &&
                        selectedOutboundAirport.value
                          ? [
                              {
                                value: "",
                                label: "Bitte Abflugzeit auswählen",
                              },
                              ...inboundStations.find(
                                (e) => e.value === selectedOutboundAirport.value
                              ).times,
                            ]
                          : []
                      }
                      value={selectedArrival}
                      isDisabled={!selectedOutboundAirport?.value}
                      onChange={(val) => {
                        setSelectedArrival(val);
                      }}
                    />
                  </div>
                </div>

                <div
                  className={
                    "classicoptions " +
                    (status === -1
                      ? "voucherno"
                      : status === 1
                      ? "voucheryes"
                      : "")
                  }
                >
                  <div className="hotelofferframe14">
                    {Array.isArray(alternativeTransports?.Offers?.Offer) &&
                      alternativeTransports.Offers.Offer.filter((e) =>
                        selectedOutboundAirport
                          ? selectedOutboundAirport.value
                            ? e.OfferServices.Package.Flight?.OutboundFlight
                                .FlightDeparture.DepartureAirportRef
                                .AirportCode === selectedOutboundAirport.value
                            : true
                          : true
                      )
                        .filter((e) =>
                          selectedDeparture
                            ? selectedDeparture.outboundairport
                              ? e.OfferServices.Package.Flight?.OutboundFlight
                                  .FlightDeparture.DepartureAirportRef
                                  .AirportCode ===
                                  selectedDeparture.outboundairport &&
                                e.OfferServices.Package.Flight?.OutboundFlight
                                  .FlightDeparture.DepartureTime ===
                                  selectedDeparture.time &&
                                e.OfferServices.Package.Flight?.OutboundFlight
                                  .FlightDeparture.DepartureDate ===
                                  selectedDeparture.date
                              : true
                            : true
                        )
                        .filter((e) =>
                          selectedArrival
                            ? selectedArrival.inboundairport
                              ? e.OfferServices.Package.Flight?.OutboundFlight
                                  .FlightDeparture.DepartureAirportRef
                                  .AirportCode ===
                                  selectedArrival.inboundairport &&
                                e.OfferServices.Package.Flight?.InboundFlight
                                  .FlightDeparture.DepartureTime ===
                                  selectedArrival.time &&
                                e.OfferServices.Package.Flight?.InboundFlight
                                  .FlightDeparture.DepartureDate ===
                                  selectedArrival.date
                              : true
                            : true
                        )
                        .sort((a, b) => {
                          return selectedArrival
                            ? selectedArrival.inboundairport
                              ? a?.OfferServices?.Package?.Flight
                                  ?.OutboundFlight?.FlightDeparture
                                  ?.DepartureTime
                                ? (
                                    a.OfferServices.Package.Flight
                                      .OutboundFlight.FlightDeparture
                                      .DepartureTime + ""
                                  ).localeCompare(
                                    b?.OfferServices?.Package?.Flight
                                      ?.OutboundFlight?.FlightDeparture
                                      ?.DepartureTime
                                  )
                                : 0
                              : 0
                            : 0;
                        })
                        .sort((a, b) => {
                          return selectedDeparture
                            ? selectedDeparture.outboundairport
                              ? a?.OfferServices?.Package?.Flight?.InboundFlight
                                  ?.FlightDeparture?.DepartureTime
                                ? (
                                    a.OfferServices.Package.Flight.InboundFlight
                                      .FlightDeparture.DepartureTime + ""
                                  ).localeCompare(
                                    b?.OfferServices?.Package?.Flight
                                      ?.InboundFlight?.FlightDeparture
                                      ?.DepartureTime
                                  )
                                : 0
                              : 0
                            : 0;
                        })
                        .sort((a, b) => {
                          return selectedOutboundAirport
                            ? selectedOutboundAirport.value
                              ? a?.OfferServices?.Package?.Flight
                                  ?.OutboundFlight?.FlightDeparture
                                  ?.DepartureTime
                                ? (
                                    a.OfferServices.Package.Flight
                                      .OutboundFlight.FlightDeparture
                                      .DepartureTime + ""
                                  ).localeCompare(
                                    b?.OfferServices?.Package?.Flight
                                      ?.OutboundFlight?.FlightDeparture
                                      ?.DepartureTime
                                  )
                                : 0
                              : 0
                            : 0;
                        })
                        .map((suboffer, i) => {
                          afct = afct + 1;
                          if (
                            !(
                              i >= 20 * (alternativeFlightPage - 1) &&
                              i < 20 * alternativeFlightPage
                            )
                          )
                            return <></>;
                          //let betterOption = checkBetter(offer, suboffer);
                          oddalternativeTransports = !oddalternativeTransports;
                          if (!(offer.OfferID === suboffer.OfferID)) {
                            evenflight = !evenflight;
                          }

                          //outboundFlight.FlightDeparture.DepartureTime
                          return offer.OfferID === suboffer.OfferID ? null : (
                            //return true ? (
                            <div
                              className={
                                evenflight
                                  ? "offerflightrow1"
                                  : "offerflightrow2"
                              }
                              style={{
                                display: "flex",
                                padding: 8,
                              }}
                            >
                              <div style={{ flex: "80%" }}>
                                <OfferFlight
                                  offer={suboffer}
                                  stations={stations}
                                  horizontal
                                />
                              </div>

                              <Offerprice
                                flexSelected={flexSelected}
                                dispatch={dispatch}
                                offer={offer}
                                co={suboffer}
                              />
                              <div
                                style={{
                                  display: "flex",
                                  marginLeft: 10,
                                  flexDirection: "column",
                                }}
                              >
                                <div style={{ flexGrow: 1 }}></div>
                                
                                <AvailabilityButton
                                  mainOffer={false}
                                  flightOffer={true}
                                  offer={suboffer}
                                  hotel={hotel}
                                  inboundView={views.hotelclassicview}
                                  parentid={offer.OfferID}
                                  availableAction={(suboffer) => {
                                    let theoff = { ...suboffer };
                                    theoff.flexbooked = flexSelected;
                                    props.changeChoosenOffers(theoff);
                                    setShowAlternativeTransports(false);
                                    window.scrollTo(0, offsetTop);
                                    getAlternativeTransports(
                                      0,
                                      true,
                                      suboffer,
                                      true
                                    );
                                    getBetterOffers(
                                      true,
                                      false,
                                      suboffer,
                                      true,
                                      true
                                    );
                                  }}
                                  availableText={"übernehmen"}
                                />
                              </div>
                            </div>
                          );
                        })}
                    {afct > 20 && (
                      <div>
                        <span>{afct} Alternative Flüge</span>
                        <br />
                        <span>Seite: </span>

                        {[...Array(Math.ceil(afct / 20))].map((e, i) => {
                          return (
                            <span>
                              {i > 0 && <>&nbsp;|&nbsp;</>}
                              <span
                                style={{
                                  fontWeight:
                                    i + 1 === alternativeFlightPage
                                      ? 700
                                      : undefined,
                                  cursor:
                                    i + 1 !== alternativeFlightPage
                                      ? "pointer"
                                      : undefined,
                                }}
                                onClick={() => {
                                  if (i + 1 !== alternativeFlightPage)
                                    setAlternativeFlightPage(i + 1);
                                }}
                              >
                                {i + 1}
                              </span>
                            </span>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
        </>
      )}

      <div style={{ marginBottom: 32 }}></div>
    </>
  );
}

const Offerprice = (props) => {
  const { co, offer, clickAction, flexSelected } = props;

  let offerrealprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    offerrealprice =
      offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    offerrealprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  if (
    Array.isArray(offer?.MarketingActions) &&
    offer.MarketingActions.length > 0 &&
    offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice &&
    flexSelected
  ) {
    offerrealprice +=
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice *
      1;
  }

  let corealprice = 0;

  if (co?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    corealprice = co?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  } else {
    corealprice =
      co.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  if (
    co.OfferID !== offer.OfferID &&
    co.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1) ===
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1)
  ) {
    console.log("ACHTUNG, WARUM GLEICH?", co, offer);
  }

  if (
    Array.isArray(co?.MarketingActions) &&
    co.MarketingActions.length > 0 &&
    co.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice &&
    flexSelected
  ) {
    corealprice +=
      co.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice * 1;
  }

  return (
    <div
      style={{ display: "flex", flexDirection: "column" }}
      className="offerupgradeitemprice"
      onClick={() => {
        //clickAction(co)
      }}
    >
      <div className="growbox"></div>
      <div>
        {corealprice > offerrealprice ? <>+&nbsp;</> : <>-&nbsp;</>}
        {nf.format(Math.abs(corealprice - offerrealprice).toFixed(0))}{" "}
        {currencySymbol(co.PriceInfo.Price.CurrencyCode)}
        &nbsp;(
        {corealprice} {currencySymbol(co.PriceInfo.Price.CurrencyCode)})
      </div>
    </div>
  );
};
